/**
 * Static FX table. Used for soft display conversions (e.g. "approximately
 * $X USD") only — never authoritative. Authoritative pricing is always
 * computed by the api-server in the trip's billing currency.
 *
 * If you add a currency here, also add it to the api-server's matching FX
 * table so server-side approximations stay in sync.
 */
const RATES_TO_USD: Record<string, number> = {
  USD: 1,
  EUR: 1.08,
  GBP: 1.27,
  CAD: 0.74,
  AUD: 0.66,
  NZD: 0.60,
  CHF: 1.14,
  JPY: 0.0067,
  SEK: 0.094,
  NOK: 0.092,
  DKK: 0.145,
  SGD: 0.74,
  HKD: 0.128,
  MXN: 0.058,
  ZAR: 0.055,
  BRL: 0.20,
};

export function fxConvert(
  amount: number | null | undefined,
  from: string | null | undefined,
  to: string | null | undefined,
): number | null {
  if (amount == null || !Number.isFinite(Number(amount))) return null;
  const fromCode = String(from || "USD").toUpperCase();
  const toCode = String(to || "USD").toUpperCase();
  if (fromCode === toCode) return Number(amount);
  const fromRate = RATES_TO_USD[fromCode];
  const toRate = RATES_TO_USD[toCode];
  if (!fromRate || !toRate) return null;
  const usd = Number(amount) * fromRate;
  return usd / toRate;
}

export function isSupportedFxCurrency(code: string | null | undefined): boolean {
  return !!RATES_TO_USD[String(code || "").toUpperCase()];
}

/** Lowercase ISO list of currencies known to the FX table — useful for
 * picker components that need the union shared between platforms. */
export function supportedFxCurrencies(): readonly string[] {
  return Object.keys(RATES_TO_USD);
}
